import { Link } from 'react-router-dom';
import { PageLayout } from '../components/Layout';
import { Button } from '../components/ui/button';
import { 
  Heart, 
  CheckCircle,
  ArrowRight,
  Sparkle,
  HandHeart,
  ChatCircle,
  UserCircle,
  MagnifyingGlass,
  FileText,
  CalendarCheck,
  Plus,
  Phone,
  EnvelopeSimple,
  Globe
} from '@phosphor-icons/react';

const Pricing = () => {
  const extraServices = [
    {
      name: "Polished Personal Résumé",
      price: "$50.00",
      features: [
        "Designed to showcase your personality and relationship goals"
      ]
    },
    {
      name: "Extra Virtual Consultation",
      price: "$50.00/hr",
      features: [
        "One on One in-depth sessions",
        "Support and guidance"
      ]
    },
    {
      name: "Date Planning",
      price: "$25.00",
      features: [
        "Suggest plans for dating purposes"
      ]
    }
  ];

  return (
    <PageLayout>
      {/* Hero */}
      <section className="py-24 md:py-32 rose-gradient">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 rounded-full text-primary text-sm font-medium shadow-sm mb-6">
              <Sparkle weight="fill" className="w-4 h-4" />
              Our Services
            </div>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-6 text-gray-800">
              What We <span className="text-primary">Offer</span>
            </h1>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-2xl mx-auto">
              All services are confidential and handled with professionalism, discretion and care.
            </p>
          </div>
        </div>
      </section>

      {/* Main Package */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          
          {/* Package Card */}
          <div 
            className="relative rounded-2xl overflow-hidden border-2 border-primary shadow-xl"
            data-testid="pricing-card-main"
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-primary to-pink-400 text-white p-8 text-center">
              <Heart weight="fill" className="w-12 h-12 mx-auto mb-4" />
              <h2 className="font-serif text-3xl md:text-4xl">Link, Laugh & Love Package</h2>
              <p className="text-pink-100 mt-4 text-lg max-w-xl mx-auto">
                A personalized virtual matchmaking experience designed to assist you in building a meaningful and compatible relationship.
              </p>
            </div>
            
            {/* Package Contents */}
            <div className="p-8 space-y-8">
              
              {/* Application Interview */}
              <div className="border-b border-pink-100 pb-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <FileText weight="fill" className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="font-serif text-xl text-gray-800">Application Interview</h3>
                </div>
                <p className="text-muted-foreground ml-13">
                  Basic Information: purpose/goals, background information, references/expectations, personality, compatibility, required documentation and consent form.
                </p>
              </div>

              {/* Create Your Profile */}
              <div className="border-b border-pink-100 pb-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <UserCircle weight="fill" className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="font-serif text-xl text-gray-800">Create Your Profile</h3>
                </div>
                <p className="text-muted-foreground ml-13">
                  Professional database entry
                </p>
              </div>

              {/* Start Your Virtual Matchmaking Plan */}
              <div className="border-b border-pink-100 pb-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <MagnifyingGlass weight="fill" className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="font-serif text-xl text-gray-800">Start Your Virtual Matchmaking Plan</h3>
                </div>
                <ul className="space-y-2 ml-13">
                  <li className="flex items-start gap-2 text-muted-foreground">
                    <CheckCircle weight="fill" className="w-4 h-4 text-primary flex-shrink-0 mt-1" />
                    Search for compatible candidates
                  </li>
                  <li className="flex items-start gap-2 text-muted-foreground">
                    <CheckCircle weight="fill" className="w-4 h-4 text-primary flex-shrink-0 mt-1" />
                    Link, Laugh & Love identify and select compatible matches based on your unique values, lifestyle and relationship goals.
                  </li>
                </ul>
              </div>

              {/* Private Relationship Advice */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <ChatCircle weight="fill" className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="font-serif text-xl text-gray-800">Private Relationship Advice (30 minutes)</h3>
                </div>
                <p className="text-muted-foreground ml-13">
                  Consultation is to collect details to better understand your needs, desires and gain clarity of who you are and the type of partner that genuinely aligns with your lifestyle.
                </p>
              </div>

              {/* CTA Button */}
              <div className="pt-6">
                <Link to="/signup">
                  <Button className="w-full btn-primary text-lg py-6">
                    <Heart weight="fill" className="w-5 h-5 mr-2" />
                    Get Started
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 rose-gradient">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 rounded-full text-primary text-sm font-medium shadow-sm mb-4">
              <Plus weight="bold" className="w-4 h-4" />
              Additional Services
            </div>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            {extraServices.map((service, index) => (
              <div key={index} className="paper-card rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="font-serif text-2xl text-primary font-bold mb-3">{service.price}</div>
                <h3 className="font-serif text-lg text-gray-800 mb-4">{service.name}</h3>
                <ul className="space-y-2">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-muted-foreground text-left">
                      <CheckCircle weight="fill" className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Thank You CTA */}
      <section className="py-24 md:py-32 navy-section">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <div className="text-4xl mb-6">❤️</div>
          <h2 className="font-serif text-3xl md:text-4xl mb-6 text-white">
            Thank You
          </h2>
          <p className="text-pink-100/80 text-lg mb-10 max-w-2xl mx-auto">
            All services are confidential and handled with professionalism, discretion and care.
          </p>
          
          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-10 text-pink-100">
            <div className="flex items-center gap-2">
              <Phone weight="fill" className="w-5 h-5" />
              <span>(810) 799-1060</span>
            </div>
            <div className="flex items-center gap-2">
              <EnvelopeSimple weight="fill" className="w-5 h-5" />
              <span>LinkLaughLoveMatch@gmail.com</span>
            </div>
            <div className="flex items-center gap-2">
              <Globe weight="fill" className="w-5 h-5" />
              <span>LinkLaughLove.com</span>
            </div>
          </div>
          
          <p className="text-pink-200 font-medium mb-8">Link, Laugh & Love Team</p>
          
          <Link to="/signup">
            <Button className="btn-primary text-lg px-12 py-6">
              <Heart weight="fill" className="w-5 h-5 mr-2" />
              Begin Your Journey
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </PageLayout>
  );
};

export default Pricing;
